import gql from 'graphql-tag'
import api from '@/services/apiLogin/apiClient'

let tokenApi = null

export const login = async () => {
  if (!isValidToken()) {
    console.log('API Login Token vencido o inválido, solicita uno nuevo')
    tokenApi = await api
      .send({
        query: gql`
          query login($usr: String!, $pwd: String!) {
            ApiLogin {
              login(usr: $usr, pwd: $pwd) {
                token
              }
            }
          }
        `,
        variables: {
          usr: process.env.NUXT_ENV_API_LOGIN_USR,
          pwd: process.env.NUXT_ENV_API_LOGIN_PWD
        }
      })
      .then(result => result.data.data.ApiLogin.login.token)
  }

  localStorage.setItem('tokenApi', tokenApi)
}

const isValidToken = () => {
  try {
    tokenApi = localStorage.getItem('tokenApi')
    if (!tokenApi) return false
    const { exp } = JSON.parse(Buffer.from(tokenApi.split('.')[1], 'base64').toString())
    const currentTime = new Date().getTime() / 1000

    if (parseInt(currentTime) >= parseInt(exp)) return false

    return true
  } catch (err) {
    console.error('[8064] Ha ocurrido un error al generar el apiLogin Token', err)
    tokenApi = null
    return false
  }
}
